import FormattedField from './FormattedField';

export default FormattedField;